export default function RangeExtractor(rangeData) {
    // Input => 0-30/5
    // Output => {
    //    start: 0
    //    end: 30
    //    count: 5
    // }
    return {
        start: Number.parseInt(rangeData.split('/')[0].split('-')[0], 10),
        end: Number.parseInt(rangeData.split('/')[0].split('-')[1], 10),
        count: Number.parseInt(rangeData.split('/')[1], 10),
    };
}

export function buildRange(page = 1, pageSize = 30) {
    const begin = (page - 1) * pageSize;
    const end = (page) * pageSize;
    return `${begin}-${end}`;
}
